import React, { useState } from 'react';
import RewardCard from './RewardCard';

const dummyRewards = {
  Active: [
    {
      id: 1,
      merchant: 'Nextloop @ Curtin',
      title: 'Free play @ claw machine',
      description: 'Flash this e-voucher to claim your rewards',
      code: '-',
      validUntil: 'Aug 22, 2024',
      status: 'Active',
    },
    {
      id: 2,
      merchant: 'Nextloop @ Curtin1',
      title: 'Free play @ claw machine',
      description: 'Flash this e-voucher to claim your rewards',
      code: '-',
      validUntil: 'Aug 22, 2024',
      status: 'Active',
    },
    {
      id: 3,
      merchant: 'Nextloop @ Curtin2',
      title: 'Free play @ claw machine',
      description: 'Flash this e-voucher to claim your rewards',
      code: '-',
      validUntil: 'Aug 22, 2024',
      status: 'Active',
    }
  ],
  Used: [
    {
      id: 4,
      merchant: 'Nextloop @ Curtin',
      title: '10% Off Drink',
      description: 'Show to barista before checkout',
      code: 'USED123',
      validUntil: 'May 01, 2024',
      status: 'Used',
    },
    {
      id: 5,
      merchant: 'Nextloop @ Curtin4',
      title: '10% Off Drink',
      description: 'Show to barista before checkout',
      code: 'USED123',
      validUntil: 'May 01, 2024',
      status: 'Used',
    },
    {
      id: 6,
      merchant: 'Nextloop @ Curtin5',
      title: '10% Off Drink',
      description: 'Show to barista before checkout',
      code: 'USED123',
      validUntil: 'May 01, 2024',
      status: 'Used',
    }
  ],
  Expired: [
    {
      id: 7,
      merchant: 'Nextloop @ Curtin',
      title: 'Free popcorn',
      description: 'Redeem at the counter',
      code: 'EXPIRED456',
      validUntil: 'Apr 15, 2024',
      status: 'Expired',
    },
    {
      id: 8,
      merchant: 'Nextloop @ Curtin',
      title: 'Free popcorn',
      description: 'Redeem at the counter',
      code: 'EXPIRED456',
      validUntil: 'Apr 15, 2024',
      status: 'Expired',
    }
  ],
};

export default function RewardsPage() {
  const [activeTab, setActiveTab] = useState('Active');

  return (
    <div className="min-h-screen bg-white p-4 mx-auto">
      <h1 className="text-2xl font-bold text-center mb-4">E - Vouchers</h1>

      <div className="flex justify-around mb-6">
        {['Active', 'Used', 'Expired'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 rounded-full text-sm font-medium ${
              activeTab === tab
                ? 'bg-black text-white'
                : 'bg-gray-200 text-gray-700'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
  {dummyRewards[activeTab].map((reward) => (
    <RewardCard key={reward.id} {...reward} />
  ))}
</div>

    </div>
  );
}
